import Popup from '@/components/Popup/PopUp/PopUp';
import Button from '@/components/shared/Button/Button';
import { Text } from '@/components/shared/Text/Text';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  isSaving: boolean;
  onStay: () => void;
  onDiscard: () => void;
  onSaveAndLeave: () => void;
}

const UnsavedChangesModal = ({
  isOpen,
  isSaving,
  onStay,
  onDiscard,
  onSaveAndLeave,
}: UnsavedChangesModalProps) => (
  <Popup
    isOpen={isOpen}
    handleClose={onStay}
    outsideClose={!isSaving}
    maxWidth={420}
    withClose={false}
  >
    <Text.Big weight="bold" className="mb-1">
      Leave without saving?
    </Text.Big>
    <Text.Regular className="text-neutral-60 mb-6">
      Changes to this journey haven’t been saved.
    </Text.Regular>
    <div className="flex justify-end gap-2">
      <Button
        label="Stay"
        variant="transparent"
        size="s"
        className="!w-20"
        disabled={isSaving}
        onClick={onStay}
      />
      <Button
        label="Discard"
        variant="transparent"
        size="s"
        className="!w-24"
        disabled={isSaving}
        onClick={onDiscard}
      />
      <Button
        label={isSaving ? 'Saving...' : 'Save & leave'}
        size="s"
        className="!w-32"
        disabled={isSaving}
        onClick={onSaveAndLeave}
      />
    </div>
  </Popup>
);

export default UnsavedChangesModal;
